import { JSX } from 'react';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import BadgeIcon from '@mui/icons-material/Badge';
import BarChartIcon from '@mui/icons-material/BarChart';
import BrandingWatermarkIcon from '@mui/icons-material/BrandingWatermark';
import BuildIcon from '@mui/icons-material/Build';
import BusinessIcon from '@mui/icons-material/Business';
import CakeIcon from '@mui/icons-material/Cake';
import CalculateIcon from '@mui/icons-material/Calculate';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CampaignIcon from '@mui/icons-material/Campaign';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import CategoryIcon from '@mui/icons-material/Category';
import ChecklistIcon from '@mui/icons-material/Checklist';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import DescriptionIcon from '@mui/icons-material/Description';
import DevicesIcon from '@mui/icons-material/Devices';
import EditNotificationsIcon from '@mui/icons-material/EditNotifications';
import EngineeringIcon from '@mui/icons-material/Engineering';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import ForumIcon from '@mui/icons-material/Forum';
import GavelIcon from '@mui/icons-material/Gavel';
import GroupsIcon from '@mui/icons-material/Groups';
import HandshakeIcon from '@mui/icons-material/Handshake';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import InsightsIcon from '@mui/icons-material/Insights';
import InventoryIcon from '@mui/icons-material/Inventory';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import MessageIcon from '@mui/icons-material/Message';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import PaymentsIcon from '@mui/icons-material/Payments';
import PeopleIcon from '@mui/icons-material/People';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PercentIcon from '@mui/icons-material/Percent';
import PinIcon from '@mui/icons-material/Pin';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import RouteIcon from '@mui/icons-material/Route';
import SavingsIcon from '@mui/icons-material/Savings';
import ScaleIcon from '@mui/icons-material/Scale';
import ScheduleIcon from '@mui/icons-material/Schedule';
import SchoolIcon from '@mui/icons-material/School';
import SensorsIcon from '@mui/icons-material/Sensors';
import SettingsIcon from '@mui/icons-material/Settings';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SouthAmericaIcon from '@mui/icons-material/SouthAmerica';
import StorefrontIcon from '@mui/icons-material/Storefront';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import TodayIcon from '@mui/icons-material/Today';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TuneIcon from '@mui/icons-material/Tune';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import KitchenIcon from '@mui/icons-material/Kitchen';

const iconMap: Record<string, JSX.Element> = {
    AccountBalance: <AccountBalanceIcon />,
    AccountBalanceWallet: <AccountBalanceWalletIcon />,
    AccountBox: <AccountBoxIcon />,
    AccountTree: <AccountTreeIcon />,
    AddBusiness: <AddBusinessIcon />,
    AdminPanelSettings: <AdminPanelSettingsIcon />,
    Assessment: <AssessmentIcon />,
    Autorenew: <AutorenewIcon />,
    Badge: <BadgeIcon />,
    BarChart: <BarChartIcon />,
    BrandingWatermark: <BrandingWatermarkIcon />,
    Build: <BuildIcon />,
    Business: <BusinessIcon />,
    Cake: <CakeIcon />,
    Calculate: <CalculateIcon />,
    CalendarMonth: <CalendarMonthIcon />,
    Campaign: <CampaignIcon />,
    CardMembership: <CardMembershipIcon />,
    Category: <CategoryIcon />,
    Checklist: <ChecklistIcon />,
    ConfirmationNumber: <ConfirmationNumberIcon />,
    CreditCard: <CreditCardIcon />,
    CreditScore: <CreditScoreIcon />,
    Description: <DescriptionIcon />,
    Devices: <DevicesIcon />,
    DirectionsTruck: <LocalShippingIcon />,
    EditNotifications: <EditNotificationsIcon />,
    Engineering: <EngineeringIcon />,
    EventAvailable: <EventAvailableIcon />,
    EventBusy: <EventBusyIcon />,
    FactCheck: <FactCheckIcon />,
    FolderZip: <FolderZipIcon />,
    Forum: <ForumIcon />,
    Gavel: <GavelIcon />,
    Groups: <GroupsIcon />,
    Handshake: <HandshakeIcon />,
    HowToReg: <HowToRegIcon />,
    Insights: <InsightsIcon />,
    Inventory: <InventoryIcon />,
    Inventory2: <Inventory2Icon />,
    LocalShipping: <LocalShippingIcon />,
    LocationCity: <LocationCityIcon />,
    ManageAccounts: <ManageAccountsIcon />,
    ManageSearch: <ManageSearchIcon />,
    MenuBook: <MenuBookIcon />,
    MeetingRoom: <MeetingRoomIcon />,
    Message: <MessageIcon />,
    MiscellaneousServices: <MiscellaneousServicesIcon />,
    MoneyOff: <MoneyOffIcon />,
    MonitorHeart: <MonitorHeartIcon />,
    Payments: <PaymentsIcon />,
    People: <PeopleIcon />,
    PersonAddAlt1: <PersonAddAlt1Icon />,
    Percent: <PercentIcon />,
    Person: <PeopleIcon />,
    Pin: <PinIcon />,
    PointOfSale: <PointOfSaleIcon />,
    PriceChange: <PriceChangeIcon />,
    QrCodeScanner: <QrCodeScannerIcon />,
    Receipt: <ReceiptIcon />,
    ReceiptLong: <ReceiptLongIcon />,
    RecordVoiceOver: <RecordVoiceOverIcon />,
    RequestQuote: <RequestQuoteIcon />,
    Route: <RouteIcon />,
    Savings: <SavingsIcon />,
    Scale: <ScaleIcon />,
    Schedule: <ScheduleIcon />,
    School: <SchoolIcon />,
    Sensors: <SensorsIcon />,
    Settings: <SettingsIcon />,
    ShoppingBag: <ShoppingBagIcon />,
    ShoppingBasket: <ShoppingBagIcon />,
    ShoppingCart: <ShoppingCartIcon />,
    SouthAmerica: <SouthAmericaIcon />,
    Storefront: <StorefrontIcon />,
    SupportAgent: <SupportAgentIcon />,
    SwapHoriz: <SwapHorizIcon />,
    Today: <TodayIcon />,
    TrendingUp: <TrendingUpIcon />,
    Tune: <TuneIcon />,
    UploadFile: <UploadFileIcon />,
    VerifiedUser: <VerifiedUserIcon />,
    ViewModule: <ViewModuleIcon />,
    VpnKey: <VpnKeyIcon />,
    Warehouse: <WarehouseIcon />,
    WhatsApp: <WhatsAppIcon />,
    WorkspacePremium: <WorkspacePremiumIcon />,
    DeliveryDining: <DeliveryDiningIcon />,
    KitchenOutlined: <KitchenIcon />,
};

export default iconMap;